<template>
  <div :style="{ height: height }" style="background: #ffffff">
    <v-layout class="aboutlist" row wrap>
      <v-flex class="about_title" style="padding: 15px 0px 5px 0px; margin-top: 40px" xs12>
        <div style="text-align: center">
          <img style="width: 64px; height: 64px" @click="addClickTimes()" src="imgs/svg/my/logo.png" />
        </div>
        <div style="text-align: center">
          <div class="about-app">{{ $t(displayName) }}</div>
          <span class="about-version">Version {{ appDispVersion }}</span>
          <span class="about_span" style="margin-left: 4px" v-if="devMode">{{ $t('测试') }}</span>
        </div>
        <!-- <div style="text-align:center;">
          <span class="about_span">扫描二维码，您的朋友可以下载{{ $t(displayName) }}客户端</span>
        </div> -->
      </v-flex>
      <!-- <v-flex class="about_title" style="margin-top: 20px;" xs12>
        <div style="width:100%;height:80px;">
          <img style="margin-left:40px;" :src="require('../assets/imgs/ioscode.png')" />
          <img
            style="float:right;margin-right:40px"
            :src="require('../assets/imgs/androidcode.png')"
          />
        </div>
        <div style="width:100%;height:20px;margin-top:10px">
          <span style="margin-left:40px;width:80px;text-align:center;font-size:14px;">苹果 二维码</span>
          <span
            style="margin-right:40px;float:right;width:80px;text-align:center;font-size:14px;"
          >安卓 二维码</span>
        </div>
      </v-flex> -->
      <v-flex v-if="false" style="margin-top: 30px" class="about_button" @click="go2Web()" xs12>
        <div>
          <p>{{ $t('网址') }}</p>
          <p style="margin-left: 30px">http://www.hzdatalink.com</p>
          <!-- <v-icon class="about_button_icon_right">keyboard_arrow_right</v-icon> -->
        </div>
      </v-flex>
      <v-flex class="about_title" style="margin-bottom: 0" xs12>
        <div style="
            position: absolute;
            bottom: 10px;
            text-align: center;
            width: 100%;
          ">
          <div class="licence-wrap">
            <span class="licence-link" @click="showLicense()">{{ $t('《软件许可与服务协议》') }}</span>
            <span class="licence-text">和</span>
            <span class="licence-link" @click="showPrivacy()">{{ $t('《隐私政策》') }}</span>
          </div>
          <eds-copyright />
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import edsCopyright from './edsCopyright'
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex'
import devHelper from '../util/devHelper'
import msgbus from '../msgBus'
import PullTo from 'vue-pull-to'
import functions from '../functions'

export default {
  name: 'iDS-About',
  components: {
    PullTo,
    edsCopyright,
  },
  data: () => ({
    licence: '',
    clickTime: 0,
    devMode: devHelper.isDevMode(), // 判断是否开启了测试模式
  }),
  computed: {
    ...mapGetters('app', [
      'displayName'
    ]),
    appDispVersion() {
      return msgbus.vm.getAppDispVersion()
    },
    height() {
      return `calc(${window.innerHeight}px - 48px ` + ')'
    },
    textHeight() {
      var text = window.innerHeight - 48 - 370
      if (text < 68) return '68px'
      else return `calc(${window.innerHeight}px - 48px - 370px` + ')'
    },
  },
  methods: {
    addClickTimes() {
      this.clickTime++
      if (this.clickTime > 1) {
        this.devMode = !this.devMode
        devHelper.setDevMode(this.devMode)
        this.clickTime = 0
      }
    },
    showLicense() {
      this.$router.push({ name: 'licence' })
    },
    showPrivacy() {
      this.$router.push({ name: 'privacy' })
    },
    go2Function() {
      this.$router.push({ name: 'function' })
    },
    go2Web() {
      // cordova.InAppBrowser.open('http://www.hzdatalink.com', '_system', 'location=no,toolbar=yes,toolbarposition=top,closebuttoncaption=关闭');
    },
    changeView() {
      msgbus.vm.setTitle('')
      msgbus.vm.setBackDisabled(false)
      msgbus.vm.setBackIcon('arrow_back')
      msgbus.vm.setBottomNavVisible(false)
      msgbus.vm.setBottomBtnVisible(false)
      msgbus.vm.setContentHeight({
        value: `calc(${window.innerHeight}px - 48px ` + ')',
      })
    },
  },
  created: function () {
    console.log('调试代码')

    // 获取显示版本信息
    functions.versionCheckHelper.funcGetAppDispVersion()

    this.changeView()
  },
  mounted: function () { },
  beforeDestroy() { },
}
</script>

<style lang="scss">
.aboutlist {
  background: #ffffff;

  .about_button {
    padding: 15px 0px 15px 10px;
    background: white;
    margin-bottom: 1px;

    div p {
      float: left;
      margin-bottom: 0px;
      margin-left: 5px;
    }

    .blue-block {
      display: block;
      float: left;

      margin: {
        left: 0.5rem;
        right: 0.2rem;
      }
    }

    &>div>span {
      overflow: hidden;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
      white-space: nowrap;
      display: block;
      float: left;
      max-width: calc(100% - 5rem);
    }

    .about_button_icon_left {
      float: left;
    }

    .about_button_icon_right {
      float: right;
      margin-right: 10px;
    }
  }

  .about_title {
    margin-bottom: 5px;
    // background: white;
  }

  .about_span {
    font-family: PingFangSC-Regular;
    font-size: 11px;
    color: #686868;
    letter-spacing: 0;
    text-align: center;
  }

  .about-app {
    color: #020202;
    font-size: 20px;
    font-weight: bold;
    line-height: 28px;
    margin-top: 10px;
  }

  .about-version {
    font-family: PingFangSC-Regular;
    color: #8c8c8c;
    font-size: 14px;
    line-height: 28px;
  }

  .licence-wrap {
    .licence-link {
      display: inline-block;
      color: #1d80dd;
      font-size: 12px;
      line-height: 28px;
      text-align: center;
    }

    & .licence-text {
      display: inline-block;
      color: rgba(0, 0, 0, 0.54);
      font-size: 12px;
      line-height: 28px;
      text-align: center;
    }
  }

  .copyright {
    color: #a6a6a6;
    font-size: 12px;
    line-height: 20px;
    text-align: center;
    margin-bottom: 5px;
  }
}
</style>
